<template>
  <InboxThreads />
</template>

<script>
import InboxThreads from "../../components/TeamInbox/InboxThreads";
export default {
  components: {
    InboxThreads
  }
};
</script>

<style lang="scss" scoped></style>
